import React from 'react';

import PostSkeleton from '../../../Components/Posts/Show/Skeleton';
import MetaTags from '../../../Components/MetaTags';
import { PostCategories, PostTypes } from '../../../Utils/Types';
import PostCreatedModal from '../../../Components/Posts/Show/PostCreatedModal';
import CommunicationWrapper from '../../../Components/Posts/Show/Communication/Wrapper';
import ParticipationWrapper from '../../../Components/Posts/Show/Participation/Wrapper';
import FolderWrapper from '../../../Components/Posts/Show/Folder/Wrapper';
import ConsultationWrapper from '../../../Components/Posts/Show/Consultation/Wrapper';
import MessagingWrapper from '../../../Components/Posts/Show/Messaging/Wrapper';
import usePostQuery from '../../../Hooks/usePostQuery';
import { isAccessingViaCustomDomain } from '../../../Utils';
import useParamsId from '../../../Hooks/useParamsId';

function PostShow({ space }: any) {
  const postId = useParamsId();
  const { post, isLoading } = usePostQuery(postId, {
    refetchOnWindowFocus: true,
  });

  if (!space || (isLoading && !post) || !post) {
    return <PostSkeleton />;
  }

  const renderShow = () => {
    if (PostTypes.IDEA === post.type) {
      return <ParticipationWrapper post={post} space={space} />;
    }

    if (PostTypes.FOLDER === post.type) {
      return <FolderWrapper post={post} space={space} />;
    }

    if (PostCategories.COMMUNICATION.includes(post.type)) {
      return <CommunicationWrapper post={post} space={space} />;
    }

    if (PostCategories.CONSULTATION.includes(post.type)) {
      return <ConsultationWrapper post={post} space={space} />;
    }

    if (PostCategories.MESSAGING.includes(post.type)) {
      return <MessagingWrapper post={post} space={space} />;
    }

    throw new Error('Post type Not Supported');
  };

  return (
    <>
      <MetaTags
        title={`${post.title} | ${space.name}`}
        description={`${post.content} | ${space.name}`}
        updatedAtIso8601={post.updated_at}
        pictureUrl={post.picture_to_share_url}
        publishedAtIso8601={post.published_at}
        ogTypeCurrentContextValue={post.type}
        noindex={space.custom_domain && !isAccessingViaCustomDomain()}
      />

      {renderShow()}

      {post && <PostCreatedModal post={post} />}
    </>
  );
}

export default PostShow;
